import { Box, Typography } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

type AmazonSelectExampleProps = {
  storeName: string;
  selectedCountry: string;
};

export const AmazonSelectExample = (props: AmazonSelectExampleProps) => {
  const { storeName, selectedCountry } = props;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignSelf: "center",
        backgroundColor: "white",
      }}
    >
      <Box
        sx={{
          border: "1px solid",
          borderColor: "grey.400",
          borderRadius: "4px",
          width: "160px",
          padding: "4px 8px",
        }}
      >
        <Typography variant="body2" textOverflow="ellipsis" overflow="auto">
          <b>{storeName} </b>| {selectedCountry}
        </Typography>
      </Box>

      <Box
        sx={{
          border: "1px solid",
          borderColor: "grey.400",
          width: "160px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignContent: "center",
          }}
        >
          <ArrowDropDownIcon fontSize="small" />
          <Typography
            variant="body2"
            fontWeight="bold"
            textOverflow="ellipsis"
            overflow="auto"
          >
            {storeName}
          </Typography>
        </Box>
        <Typography sx={{ paddingLeft: "20px" }} variant="body2">
          XXX... Market
        </Typography>
        <Typography
          sx={{ paddingLeft: "20px", backgroundColor: "grey.300" }}
          variant="body2"
        >
          {selectedCountry}
        </Typography>
        <Typography sx={{ paddingLeft: "20px" }} variant="body2">
          YYY... Market
        </Typography>
        <Box
          sx={{
            borderTop: "1px solid",
            borderColor: "grey.400",
            justifyContent: "center",
            display: "flex",
            padding: "2px",
          }}
        >
          <Typography variant="body2">See All</Typography>
        </Box>
      </Box>
    </Box>
  );
};
